import { render, staticRenderFns } from "./ServiceRequestFlow.vue?vue&type=template&id=b270cae0&scoped=true&"
import script from "./ServiceRequestFlow.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestFlow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestFlow.vue?vue&type=style&index=0&id=b270cae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b270cae0",
  null
  
)

export default component.exports